import React from "react";
import AdminLayout from "./AdminLayout";
import { useAuth } from "../context/AuthContext";

interface AdminLayoutWrapperProps {
  children: React.ReactElement;
}

const AdminLayoutWrapper: React.FC<AdminLayoutWrapperProps> = ({ children }) => {
  const { role } = useAuth();

  // Only wrap with AdminLayout if user is admin
  if (role === "admin") {
    return <AdminLayout>{children}</AdminLayout>;
  }

  return children;
};

export default AdminLayoutWrapper;

